import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  static values = {
    emittable: String,
  }

  connect = () => {
    if (this.isLoaded) {
      this.emitValue()
    }
  }

  emitValue = () => {
    emit(this.emittableValue, {
      bubbles: true,
    })
  }

  get isLoaded() {
    return this.element.complete
  }
}
